<h2>Duty {{ tripType }}</h2>
<div class="vspace-32px"></div>

<form
	[formGroup]="form"
	*ngIf="form"
	class="container"
>
	<div class="left-column">
		<!-- column 1  -->
		<div class="form-group">
			<!-- Inspection Types  -->
			<div class="label">Select inspection types</div>
			<div class="vspace-16px"></div>

			<app-missing-input [show]="!hasSelectedInspectionTypes && isLeftActive">
				<app-multi-select-chips
					placeholder="Add inspection type"
					[disabled]="numberOfSelectedInspectionTypes === 5"
					[options]="inspectionTypes"
					(added)="inspectionTypeAdded($event)"
					(removed)="inspectionTypeRemoved($event)"
				></app-multi-select-chips>
			</app-missing-input>
			<div
				class="max-5-inspection-types"
				*ngIf="numberOfSelectedInspectionTypes === 5"
			>
				Maximum of 5 inspection types allowed.
			</div>

			<div class="vspace-32px"></div>

			<!-- start condition  -->
			<div class="label">Inspection is expected when selected event occurs:</div>
			<div class="vspace-16px"></div>

			<app-missing-input [show]="!hasStartCondition && isLeftActive">
				<div class="start-condition want-error-border">
					<!-- power  -->
					<label>
						<input
							type="radio"
							formControlName="startCondition"
							[value]="'power'"
							(change)="onRadioBtnChange(radioButtonValues.POWER)"
						/>
						{{ powerLabel[semantics] }}
					</label>

					<ng-container *ngIf="wantMovementOption">
						<div class="vspace-8px"></div>
						<!-- moves -->
						<label>
							<input
								type="radio"
								formControlName="startCondition"
								[value]="'after_distance'"
								(change)="onRadioBtnChange(radioButtonValues.MOVES)"
							/>
							Vehicle moves 10 miles radius
						</label>
					</ng-container>
					<!-- select zones -->
					<div class="vspace-8px"></div>

					<label class="hspace-16px">
						<input
							id="zone-radio-btn"
							type="radio"
							formControlName="startCondition"
							[value]="'selected-zone'"
							(change)="onRadioBtnChange(radioButtonValues.ZONE)"
						/>
						When selected zones {{ whenZoneLabel[semantics] }}
					</label>
					<div class="vspace-8px"></div>
				</div>
			</app-missing-input>

			<app-missing-input [show]="!disableZoneDropdown && !hasZonesSelected">
				<div class="zones">
					<!-- zones "dropdown" (just a btn with a down arrow for simplicity since it opens to a modal) -->
					<button
						type="button"
						class="zone-selector border want-error-border"
						(click)="openCategoryZoneDialog()"
						[disabled]="disableZoneDropdown"
					>
						<div>
							<p>{{ zonesSelectionLabel }}</p>
							<mat-icon>keyboard_arrow_down</mat-icon>
						</div>
					</button>
				</div>
			</app-missing-input>

			<!-- expire minutes -->
			<div class="expire-minutes">
				Inspection is expected
				<select
					formControlName="expireMinutes"
					class="timezone want-error-border"
					aria-label="Expire minutes"
				>
					<option
						*ngFor="let minuteOption of minuteOptions"
						[value]="minuteOption.value"
					>
						{{ minuteOption.label }}
					</option>
				</select>
				{{ tripType === 'Start' ? 'before' : 'after' }} the event.
			</div>
			<div class="vspace-32px"></div>

			<!-- frequency  -->
			<div class="label">How often inspection is expected for the selected event:</div>
			<div class="vspace-8px"></div>

			<app-missing-input [show]="false">
				<div class="form-group">
					<div class="frequency want-error-border">
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.trip"
								checked="true"
							/>
							Every time the event occurs
						</label>
						<div class="vspace-8px"></div>
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.workPeriod"
							/>
							Once per work period
						</label>
						<div class="vspace-8px"></div>
						<label>
							<input
								type="radio"
								formControlName="frequency"
								[value]="TripFrequency.tripWithinWorkperiod"
								checked="false"
							/>
							Every time the event occurs within the work period
						</label>
					</div>
				</div>
			</app-missing-input>
		</div>
	</div>
	<div
		class="right-column"
		*ngIf="isWorkPeriodFrequency"
	>
		<!-- Column 2 -->
		<div class="label">Define work period when inspection is selected</div>
		<div class="vspace-8px"></div>

		<!-- time zone  -->
		<app-missing-input
			[show]="form.get('timeZone')?.invalid && isRightActive"
			*ngIf="workPeriods.length > 0"
		>
			<select
				formControlName="timeZone"
				class="timezone want-error-border"
				aria-label="Time Zone"
			>
				<option value="">Time Zone</option>
				<option
					*ngFor="let tz of timeZones"
					[value]="tz.value"
				>
					{{ tz.label }}
				</option>
			</select>
		</app-missing-input>
		<!-- work periods  -->
		<div class="form-group">
			<ng-container formArrayName="workPeriods">
				<div
					*ngFor="let period of workPeriods.controls; let i = index"
					[formGroupName]="i"
					class="work-period"
				>
          <button
						*ngIf="workPeriods.controls.length > 1"
						class="remove-btn"
						(click)="removeWorkPeriod(i)"
            aria-label="Remove work period"
            type="button"
					>
            <mat-icon class="icon-close" aria-hidden="true">close</mat-icon>
            </button>
					<label>
						<input
							#allWeekCheckbox
							type="checkbox"
							formControlName="allWeek"
							(change)="onAllWeek($event, i)"
						/>
						All week
					</label>

					<div class="days-time-range">
						<!-- select days  -->
						<app-missing-input [show]="!hasAnyDaySelected(i) && isRightActive">
							<div class="days-range want-error-border">
								<div
									class="days"
									[formGroupName]="'days'"
								>
									<label
										*ngFor="let day of weekdays; let d = index"
										class="day-label"
										tabindex="0"
										role="checkbox"
										[attr.aria-checked]="period.get('days')?.get(dayFormKeys[d])?.value"
										(keydown.space)="$event.preventDefault(); toggleDayCheckbox(i, d)"
										(keydown.enter)="toggleDayCheckbox(i, d)"
									>
										<input
											type="checkbox"
											[formControlName]="dayFormKeys[d]"
											class="hidden"
											aria-hidden="true"
										/>
										<div
											class="day"
											[ngClass]="{ selected: period.get('days')?.get(dayFormKeys[d])?.value }"
										>
											{{ day }}
											<mat-icon
												class="check-icon"
												*ngIf="period.get('days')?.get(dayFormKeys[d])?.value"
												aria-hidden="true"
											>
												check
											</mat-icon>
										</div>
									</label>
								</div>
							</div>
						</app-missing-input>

						<!-- select time  range -->
						<div class="time-range">
							<app-missing-input [show]="isStartTimeMissing(i) && isRightActive">
								<div class="want-error-border time">
									<app-time-picker
										label="Start"
										[value]="period.get('start')?.value"
										(timeChange)="updateStartTime($event, i)"
									></app-time-picker>
								</div>
							</app-missing-input>

							<div class="hspace-16px"></div>
							<app-missing-input [show]="isEndTimeMissing(i) && isRightActive">
								<div class="want-error-border time">
									<app-time-picker
										label="End"
										[resetTimeWhenMeridiemChanges]="true"
										[value]="period.get('end')?.value"
										[showNotifier]="isNotifierShowed(i)"
										[disabled]="isStartTimeMissing(i)"
										(timeChange)="updateEndTime($event, i)"
									></app-time-picker>
								</div>
							</app-missing-input>
						</div>
					</div>
				</div>
			</ng-container>

			<div class="vspace-16px"></div>

			<app-circle-button
				*ngIf="workPeriods.controls.length < 3"
				(clicked)="addWorkPeriod()"
				[diameterPx]="30"
				[label]="addLabel"
			>
				+
			</app-circle-button>
		</div>
	</div>
</form>
